import withStyles from "@material-ui/core/styles/withStyles";
import ListItemText from "@material-ui/core/ListItemText";

export default withStyles({
  root: {
    flex: "initial",
  },
})(ListItemText);
